module.exports = __webpack_public_path__ + "img/icons8-process-100_75.b8d9b758.png";